const FREE_DELIVERY_GOAL = 3000;
const currencySymbol = "Rs. ";

function updateFreeDeliveryBar(cart) {
  const bar = document.getElementById("free-delivery-bar");
  const progress = document.getElementById("free-delivery-progress");
  const amount = cart.total_price / 100;

  if (!bar || !progress) return;

  const percent = Math.min((amount / FREE_DELIVERY_GOAL) * 100, 100);
  progress.style.width = percent + "%";

  if (amount >= FREE_DELIVERY_GOAL) {
    bar.style.backgroundColor = "#28a745";
    bar.style.color = "#fff";
    progress.style.backgroundColor = "#28a745";
    bar.querySelector(".bar-text").innerHTML = "🎉 Congratulations! You've got FREE DELIVERY! 🎉";

    if (!sessionStorage.getItem("confettiFired")) {
      sessionStorage.setItem("confettiFired", "true");
      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
      });
    }

  } else {
    sessionStorage.removeItem("confettiFired");
    const remaining = FREE_DELIVERY_GOAL - amount;
    bar.style.backgroundColor = "#ffff00";
    bar.style.color = "#000";
    progress.style.backgroundColor = "#000";
    bar.querySelector(".bar-text").innerHTML = amount > 0
      ? `🚚 You’re only ${currencySymbol}${remaining.toLocaleString()} away from FREE DELIVERY!`
      : `🚚 FREE DELIVERY on orders over ${currencySymbol}${FREE_DELIVERY_GOAL.toLocaleString()}!`;
  }
}

function fetchCartAndUpdateBar() {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => updateFreeDeliveryBar(cart))
    .catch(err => console.error("Cart fetch failed:", err));
}

document.addEventListener("DOMContentLoaded", function () {
  const bar = document.createElement("div");
  bar.id = "free-delivery-bar";
  bar.style.position = "fixed";
  bar.style.top = "0";
  bar.style.left = "0";
  bar.style.width = "100%";
  bar.style.zIndex = "99";
  bar.style.textAlign = "center";
  bar.style.fontWeight = "bold";
  bar.style.padding = "0";
  bar.style.backgroundColor = "#ffff00";
  bar.style.color = "#000";
  bar.style.fontSize = "14px";
  bar.style.transition = "transform 0.3s ease-in-out";
  bar.style.transform = "translateY(0%)";

  bar.innerHTML = `
    <div class="bar-text" style="padding: 10px;">
      🚚 FREE DELIVERY on orders over ${currencySymbol}${FREE_DELIVERY_GOAL.toLocaleString()}!
    </div>
    <div style="width: 100%; height: 5px; background-color: #ddd;">
      <div id="free-delivery-progress" style="height: 5px; width: 0%; background-color: #000; transition: width 0.5s ease;"></div>
    </div>
  `;

  document.body.prepend(bar);
  document.body.style.paddingTop = "50px"; // ✅ FIXED: prevents hidden content on load

  fetchCartAndUpdateBar();

  // Add to cart
  document.body.addEventListener("click", function (e) {
    if (e.target.matches("form[action='/cart/add'] [type='submit'], [data-add-to-cart]")) {
      setTimeout(fetchCartAndUpdateBar, 1000);
    }
  });

  // Quantity + / -
  document.body.addEventListener("click", function (e) {
    if (
      e.target.closest(".quantity__button") ||
      e.target.closest(".cart__qty-adjust") ||
      e.target.closest(".qty-button")
    ) {
      setTimeout(fetchCartAndUpdateBar, 1000);
    }
  });

  // Native Shopify cart refresh
  document.addEventListener("cart:refresh", fetchCartAndUpdateBar);

  // Scroll behavior — show/hide bar and adjust spacing
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop) {
      // Scrolling down — show bar
      bar.style.transform = "translateY(0%)";
      document.body.style.paddingTop = "50px";
    } else {
      // Scrolling up — hide bar
      bar.style.transform = "translateY(-100%)";
      document.body.style.paddingTop = "0px";
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
});